import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { CaseIncident } from '../../_types/case-incident';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { CasesIncidentsService } from '../../_services/cases-incidents.service';
import { firstValueFrom } from 'rxjs';
import { IncidentsTypesService } from 'src/app/modules/incidents-types/_services/incidents-types.service';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { ThirdPartiesService } from 'src/app/modules/transactions/_services/third-parties.service';
import { Case } from '../../_types/case';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-incidents',
    templateUrl: './incidents.component.html',
    styleUrls: ['./incidents.component.css'],
    standalone: false
})
export class IncidentsComponent implements OnInit {
  public incidentFormGroup!: RxFormGroup;
  public incident : CaseIncident = new CaseIncident();
  public sources: any[] = [
    { name: 'Operario', id: 'Worker' },
    { name: 'Tramitador', id: 'User' },
    { name: 'Compañía', id: 'Company' }
  ]
  public isApplicableOptions: any[] = [
    { name: 'Pendiente', id: null },
    { name: 'SI', id: true },
    { name: 'NO', id: false }
  ]
  public thirdParties: any[]=[];
  public incidentTypes: any[] = [];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public case: Case = new Case();
  public caseServicesWorkersIds: string[] = [];

  constructor(private config: DynamicDialogConfig,
      private dynamicDialogRef: DynamicDialogRef,
      private messageService: MessageService,
      private confirmationService: ConfirmationService,
      private formBuilder: RxFormBuilder,
      private formValidationService: FormValidatorService, 
      private caseIncidentsService: CasesIncidentsService, 
      private incidentsTypesService: IncidentsTypesService,
      private thirdPartiesService: ThirdPartiesService, 
    private loginService: LoginService)
  { 
    this.case = this.config.data.case;
    this.caseServicesWorkersIds = this.config.data.caseServicesWorkersIds;

    this.incident.date = new Date();
    this.incident.caseId = this.config.data.caseId;
    this.incident.source = 'Worker';
    this.incidentFormGroup = this.formBuilder.formGroup<CaseIncident>(this.incident) as RxFormGroup;
    
    this.allowWrite = this.loginService.hasPermission("CASES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");
  }

  ngOnInit() {
    let incidentId = this.config.data.id;
    if (incidentId) {
      this.loadIncident(incidentId);
    }else{
      this.onSourceChange({ value: this.incident.source });

    }
  }

  async loadIncident(incidentId:string){
    this.incident = await firstValueFrom(this.caseIncidentsService.get(incidentId));
    this.incidentFormGroup.patchValue(this.incident);
    this.onSourceChange({ value: this.incident.source });

  }

  onSourceChange(event: any) {
    //Cargamos los tipos de incidencia
    this.loadIncidentsType(event.value);

    //Buscamos los thirdparies
    this.loadThirdParties( event.value);
  }

  async loadIncidentsType(source: string){
    let params: IParamsCollection = { }
    //creamos filtros
    params.filter = FilterBuilder.fromObject({source : new Filter(FilterOperation.equals, 'source', '', source)}).build();

    let response = await firstValueFrom(this.incidentsTypesService.all(params));
    this.incidentTypes = response.data;
    if(this.incidentTypes.length == 1) this.incidentFormGroup.patchValue({ incidentTypeId: this.incidentTypes[0].id });
  }

  async loadThirdParties(source: string) {
      let params: IParamsCollection = { }   ;
      //creamos filtros
      let filters = {
        thirdPartyType: new Filter(FilterOperation.equals, 'thirdPartyType', '', source),
        id: new Filter(FilterOperation.equals, 'id', '')
      }

      if(source == 'Company'){
        filters.id = new Filter(FilterOperation.equals, 'id', '', this.case.companyId);
      }else if(source == 'Worker'){
        if(this.caseServicesWorkersIds.length > 0 ) filters.id = new Filter(FilterOperation.any, 'id', '', this.caseServicesWorkersIds);
      }

      params.filter = FilterBuilder.fromObject(filters).build();        

      let response = await firstValueFrom(this.thirdPartiesService.all(params));    
      this.thirdParties = response.data;
      if(source == 'Worker' && this.caseServicesWorkersIds.length == 0) this.thirdParties = [];

      if(this.thirdParties.length == 1) this.incidentFormGroup.patchValue({ thirdPartyId: this.thirdParties[0].id });
      
    }
  

  cancel() {
    this.dynamicDialogRef.close();
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.incidentFormGroup);
    if (valid) {
      this.incident = Object.assign(this.incident, this.incidentFormGroup.value);

      let note = await firstValueFrom(this.caseIncidentsService.save(this.incident));

      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Incidencia guardada correctamente." });
      this.dynamicDialogRef.close(this.incident.id ? null : note.id);

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la incidencia?",
      header: "Eliminar incidencia",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.caseIncidentsService.delete(this.incident.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Incidencia eliminada correctamente." });
            this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }
}
